/** Rotas internas (basename /SisPro/frontend é aplicado pelo BrowserRouter). */
export const routes = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
  protocolos: '/protocolos',
  novoProtocolo: '/protocolos/novo',
  protocolo: (id) => `/protocolos/${id}`,
  formulario: (protocoloId) => `/formulario/${protocoloId}`,
  analise: (protocoloId) => `/analise/${protocoloId}`,
  tecnicoAnalises: '/tecnico/analises',
  tecnicoVistorias: '/tecnico/vistorias',
  adminSisobra: '/admin/sisobra',
  adminUsuarios: '/admin/usuarios',
};

/** Paths do React Router com parametros (:id) — espelham <Route path> em App.js */
export const routePatterns = {
  protocolo: '/protocolos/:id',
  formulario: '/formulario/:protocolo_id',
  analise: '/analise/:protocolo_id',
};
